import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Amplify, { API, graphqlOperation, I18n } from 'aws-amplify';
import { getAppointment } from '../../graphql/queries';
import { updateAppointment } from '../../graphql/mutations';

const AppointmentConfirmation = () => {
  const { id } = useParams();
  const [appointment, setAppointment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [confirming, setConfirming] = useState(false);

  useEffect(() => {
    const fetchAppointment = async () => {
      try {
        var AppointmentData = await API.graphql({ ...graphqlOperation(getAppointment, {id: id }), authMode: "API_KEY" });
        console.log(AppointmentData);
        //const response = await fetch(`${process.env.REACT_APP_API_URL}/appointment/${id}`);
        const data = AppointmentData.data.getAppointment;
        setAppointment(data);
      } catch (error) {
        console.error('Error cargando cita:', error);
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchAppointment();
  }, [id]);

  const handleConfirm = async () => {
    setConfirming(true);
    try {
      await API.graphql({
        ...graphqlOperation(updateAppointment, {
          input: {
            id: id,
            status: 'CONFIRMADO'
          }
        }),
        authMode: "API_KEY"
      });
      alert('Su cita ha sido confirmada');
      window.close();
    } catch (error) {
      console.error('Error confirmando cita:', error);
      alert('Error al confirmar la cita');
    } finally {
      setConfirming(false);
    }
  };

  if (loading) return <p>Cargando...</p>;
  if (!appointment) return <p>Cita no encontrada</p>;

  return (
    <div style={{ maxWidth: '400px', margin: '40px auto', padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2>Confirmar Cita</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
          Tipo de Cita:
        </label>
        <input
          type="text"
          value={appointment.appointmentType.title || ''}
          readOnly
          style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f5f5f5' }}
        />
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>
          Horario:
        </label>
        <input
          type="text"
          value={appointment.appointmentSlot || ''}
          readOnly
          style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f5f5f5' }}
        />
      </div>

      <button
        onClick={handleConfirm}
        disabled={confirming}
        style={{
          width: '100%',
          padding: '12px',
          backgroundColor: '#0E225D',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontWeight: 'bold',
          cursor: confirming ? 'not-allowed' : 'pointer',
          opacity: confirming ? 0.7 : 1
        }}
      >
        {confirming ? 'Confirmando...' : 'Confirmar'}
      </button>
    </div>
  );
};

export default AppointmentConfirmation;
